//import {Validar} from "../../validar-multas";
import { endpoints } from "./endpoints";
import axios from "axios";

const BASEURL = process.env.VUE_APP_API_SERVEL;
const getAll = async (filters) => {
console.log('filters', filters);
    const url = `${BASEURL}${endpoints.multas}`
    return axios.get(url,{params:filters}).then(response => { 
        return response.data.data;
    });
}

const send = async (data) => {

    try {
    const url = `${BASEURL}${endpoints.multas}`
    return axios.post(url,data).then(response => { 
       return response.data;
    });
    } catch (error) {
        throw error
    }

}
const descargar = async (data) => {

    try {

    const url = `${BASEURL}${endpoints.multas}/descargar`
    return axios.post(url, data).then(response => { 
       return response.data;
    });
    } catch (error) {
        throw error
    }

}

export const MultasService = {
    getAll,
    send,
    descargar
    // exportTeacherListExcel
}